import React, { FC } from 'react';

import {
  Box,
  Flex,
  Stack,
  Modal,
  Button,
  ModalBody,
  IconButton,
  SimpleGrid,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react';

import { HiMinusCircle } from 'react-icons/hi';

import { Form, Formik } from 'formik';

import FormikInput from 'components/primitives/FormikInput';
import FormikSelectInput from 'components/primitives/FormikSelectInput';

import { selectors } from 'store/slices/washhub';

import { initialValues, validationSchema } from './AddCaseModal.utils';

import { AddCaseModalViewProps } from './AddCaseModal.props';

const labelProps = {
  fontSize: '12px',
  color: '#afafaf',
};

const AddCaseModalView: FC<AddCaseModalViewProps> = (props) => {
  const { skus, isOpen, onClose, onSubmit, isLoading, isLoadingSKU } = props;

  const washHub = selectors.useSelectedWashHub();

  return (
    <Modal
      size="6xl"
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader textAlign="center" fontWeight="500">
          Add new case
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" px={6} pb={6}>
            <Formik
              onSubmit={onSubmit}
              initialValues={initialValues}
              validationSchema={validationSchema}>
              {({ values, setFieldValue }) => (
                <Form>
                  <Flex direction="column">
                    <Flex>
                      <FormikSelectInput
                        placeholder="Select"
                        label="Select SKU (*)"
                        isLoading={isLoadingSKU}
                        containerProps={{ flex: 1 }}
                        name="sku"
                        labelProps={labelProps}>
                        {skus?.map((s) => (
                          <option key={s._id} value={s._id}>
                            {s?.name || ''}
                          </option>
                        ))}
                      </FormikSelectInput>
                      <Box h="20px" w="20px" />
                      <FormikInput
                        name="washHub"
                        label="Wash Hub"
                        labelProps={labelProps}
                        isReadOnly
                        containerProps={{ flex: 1 }}
                        value={washHub?.name || ''}
                      />
                    </Flex>
                    <SimpleGrid mt={2} columns={2} spacingX={5}>
                      {values.rfids.map((d, i) => (
                        <Flex
                          key={`-${i}`}
                          position="relative"
                          alignItems="flex-end">
                          <FormikInput
                            id={`count-${i}`}
                            name={`rfids[${i}]`}
                            label="Case ID (*)"
                            labelProps={labelProps}
                            containerProps={{ flex: 1 }}
                          />
                          {i > 0 && (
                            <IconButton
                              aria-label="remove-case"
                              icon={
                                <HiMinusCircle size="25px" fill="#E54444" />
                              }
                              size="sm"
                              variant="ghost"
                              position="absolute"
                              right={-8}
                              mb={1}
                              onClick={() =>
                                setFieldValue(
                                  'rfids',
                                  values?.rfids?.filter((_, j) => j !== i),
                                )
                              }
                            />
                          )}
                        </Flex>
                      ))}
                    </SimpleGrid>
                  </Flex>

                  <Flex flex={1} mt={8} w="100%">
                    {values?.rfids?.length <= 7 && (
                      <Button
                        w="100%"
                        size="lg"
                        borderRadius="5px"
                        variant="outline"
                        bg="primary.900"
                        onClick={() =>
                          setFieldValue('rfids', [...values?.rfids, ''])
                        }>
                        Add Case (max 8)
                      </Button>
                    )}
                  </Flex>
                  <Stack mt={6} align="center">
                    <Button type="submit" w="200px" isLoading={isLoading}>
                      Create
                    </Button>
                    <Button w="200px" onClick={onClose} isDisabled={isLoading}>
                      Cancel
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddCaseModalView;
